import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const addClusterComment = {
  name: "addClusterComment" as const,
  input: z.object({ clusterId: zExt.objectId(), content: z.string() }),
  output: z.object({ success: z.boolean() }),
};
